import React from "react";

import AppLogoStepOne from "img/how-to-img/app-logo.png";
import PackageStepTwo from "img/how-to-img/product-package.png";
import PayStepThree from "img/how-to-img/pay.png";
import VisaStepFour from "img/how-to-img/visa.png";
import CorrectStepFive from "img/how-to-img/cirecle-correct.png";

export default function HowToTraveller() {
  return (
    <div className="step-list">
            <h1 className="small-heading">Steps to Pay for a Delivery</h1>

      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={AppLogoStepOne}
            alt="Step One"
            style={{ width: "320px" }}
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 1: Open the Tripple Air App
          </h1>
          <p className="small-para">
            Launch the Tripple Air mobile app on your device. Make sure you're
            logged in with your registered account to access your delivery
            dashboard.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={PackageStepTwo}
            alt="Step Two"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 2: Go to 'My Deliveries' & Select a Delivery
          </h1>
          <p className="small-para">
            Tap on the "My Deliveries" section from the bottom menu. Choose the
            delivery you wish to pay for if it hasn't been prepaid.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={PayStepThree}
            alt="Step Three"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 3: Tap 'Make Payment'
          </h1>
          <p className="small-para">
            On the delivery details screen, tap the "Make Payment" button. This
            will bring up your available payment options.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={VisaStepFour}
            alt="Step Four"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 4: Select 'Credit/Debit Card'
          </h1>
          <p className="small-para">
            Choose "Credit/Debit Card" as your payment method. If you haven't
            added a card before, you'll be prompted to enter your card number,
            expiry date, CVV, and billing name.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={CorrectStepFive}
            alt="Step Five"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 5: Confirm and Pay
          </h1>
          <p className="small-para">
            Review the payment summary and delivery charges. Once everything
            looks good, tap "Confirm Payment." You'll get a confirmation message
            and receipt within the app and via email.
          </p>
        </div>
      </div>
    </div>
  );
}
